import { ROLE_CODES } from "@/constants";

export function isProgramAdmin(roleCode?: string): boolean {
  return roleCode === ROLE_CODES.PROGRAM_ADMIN;
}

export function isMerchantAdmin(roleCode?: string): boolean {
  return roleCode === ROLE_CODES.MERCHANT_ADMIN;
}

export function isLoyyalAdmin(roleCode?: string): boolean {
  return roleCode === ROLE_CODES.LOYYAL_ADMIN;
}

export function isPerkPointAdmin(roleCode?: string): boolean {
  return roleCode === ROLE_CODES.PERK_POINT_ADMIN;
}

export function isPerkPointProgramAdmin(roleCode?: string): boolean {
  return roleCode === ROLE_CODES.PERK_POINT_PROGRAM;
}

/** Roles that should not see the Extras sidebar section */
export function shouldHideExtrasSection(roleCode?: string): boolean {
  return isProgramAdmin(roleCode) || isMerchantAdmin(roleCode);
}

/** Hide Accounting Entries in Access Point sidebar */
export function shouldHideAccessPointAccountingEntries(
  roleCode?: string
): boolean {
  return isProgramAdmin(roleCode) || isMerchantAdmin(roleCode);
}

/** Hide Analytics in sidebar */
export function shouldHideAnalytics(roleCode?: string): boolean {
  return isMerchantAdmin(roleCode);
}

/** Merchant admin can manage stores without UPDATE_MERCHANT permission */
export function canManageMerchantStores(
  roleCode: string | undefined,
  hasUpdateMerchantPermission: boolean
): boolean {
  return isMerchantAdmin(roleCode) || hasUpdateMerchantPermission;
}
